import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				display: "flex",
				alignItems: "center",
				flexDirection: "row-reverse"
			},
			rootMessage: {
				padding: 10,
				position: "fixed",
				top: 0,
				zIndex: 22222
			},
			rootAlert: {
				border: "1px solid",
				borderRadius: 6,
				background: theme.palette.common.white,
				padding: "0px 10px",
				display: "flex",
				alignItems: "center"
			},
			iconSuccess: {
				color: theme.palette.success.main,
				borderLeft: `2px solid ${theme.palette.success.main}`,
				padding: "0px 0px  0px 10px"
			},
			iconError: {
				color: theme.palette.error.main,
				borderLeft: `2px solid ${theme.palette.error.main}`,
				padding: "0px 0px  0px 10px"
			}
		}),
	{
		name: "AlertMessage",
		index: 1
	}
);

export default useStyles;
